/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 基礎元件
 * @module web/components/BaseComponent
 */

// ----- import from npm modules -----
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

// ---- Enums -----
/**
 * 存取模式 Enum
 */
const AccessModeEnums = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete'
};

/**
 * 模組名稱 Enum
 */
const ModuleEnums = {
  ELEVATOR: '電梯資料',
  ELEVATOR_APPLY: '梯控申請',
  ELEVATOR_CONTROL_HISTORY: '梯控歷史記錄',
  BUILDING: '大樓資料',
  ROLE_PERMISSION: '角色權限',
  RESIDENT: '住戶資料',
  ACCOUNT_MANAGEMENT: '帳號管理',
  FLOOR: '樓層設定',
  DEVICE: '梯控設定',
  ROLE: '角色維護',
  POSITION: '職位資訊',
  CONTROL_CODE: '梯控信號',
};

class BaseComponent extends Component {
    constructor(props) {
      super(props);
    }

    /**
     * 取得URL
     * @param {*} path 
     * @returns 
     */
    getUrl(path) {
      return path;
    }

    /**
     * 檢查頁面權限不符合的要跳轉頁面
     * @param {String} moduleName 模組名稱
     * @param {String} mode 模式 {create, read, update, delete}
     */
    checkPermission(moduleName, mode = 'read') {
        const { userPermissions } = this.props;
  
        // Check if has userPermissions array
        if (!Array.isArray(userPermissions)) {
            console.error('userPermissions is not an array:', userPermissions);
            window.location = this.getUrl('/permission-denied');
            return false;
        }
  
        // Define a helper function to check permission recursively
        const checkPermissionRecursive = (permissions, moduleName, mode) => {
            for (let i = 0; i < permissions.length; i++) {
                const permission = permissions[i];
                if (permission.moduleName === moduleName) {
                    switch (mode) {
                        case AccessModeEnums.CREATE:
                            return permission.flgCreate === 1;
                        case AccessModeEnums.READ:
                            return permission.flgRead === 1;
                        case AccessModeEnums.UPDATE:
                            return permission.flgUpdate === 1;
                        case AccessModeEnums.DELETE:
                            return permission.flgDelete === 1;
                        default:
                            return false;
                    }
                }
                if (permission.children && permission.children.length > 0) {
                    const hasPermission = checkPermissionRecursive(permission.children, moduleName, mode);
                    if (hasPermission) {
                        return true;
                    }
                }
            }
            return false;
        };
    
        // Use the helper function to check permission
        return checkPermissionRecursive(userPermissions, moduleName, mode);
    }
}
  
BaseComponent.propTypes = {

};
  
BaseComponent.defaultProps = {

};

export {
    React,
    BaseComponent,
    AccessModeEnums,
    ModuleEnums,
    withTranslation,
    bindActionCreators,
    connect,
    PropTypes,
};